export default {
    key: "groceryMarket",
    basePath: "/groceryMarket",
    exclude: false,
    components: [],
  };
  